<script setup>
const config = useRuntimeConfig()
</script>
<template>
	<div class="login-layout">
		<VApp>
			<VMain>
				<NuxtPage :transition="{ name: 'fade', mode: 'out-in'}"/>
			</VMain>
			<CoreNotification />
			<v-footer app height="40"><v-spacer />
				v.{{config.public.version}} ©  {{ (new Date()).getFullYear() }}
				<a class='ml-1' target="_blank" href="https://depalop.com"> Depalop</a>, made with ❤️</v-footer>
		</VApp>
	</div>
</template>